import { Box } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Button, EqualWidthGrid } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { UpdateCertificateRequestDto } from "~/gen/api"

type Props = {
  form: UseFormReturnType<UpdateCertificateRequestDto>
  submit: () => void
  isLoading?: boolean
}

export function CertificateFormSubmitButton({
  form,
  submit,
  isLoading,
}: Props) {
  const { t } = useTranslation("certificates")
  const errors = Object.entries(form.errors)
    .map(([key, value]) => `${key}: ${value}`)
    .join(", ")
  return (
    <EqualWidthGrid>
      <Box style={{ flex: 0.7 }}>
        <Button
          fullWidth={true}
          disabled={!form.isValid() || isLoading}
          loading={isLoading}
          onClick={submit}
          toolTip={errors ?? undefined}
          mt="sm"
        >
          {t("modal.submit")}
        </Button>
      </Box>
    </EqualWidthGrid>
  )
}
